import { render } from "./ResourceEdit.vue?vue&type=template&id=6fa7b56e"
import script from "./ResourceEdit.vue?vue&type=script&lang=js"
export * from "./ResourceEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__